import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const BuyerManagementStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  /* .main-content {
    min-width: 1600px;
  } */

  .table-wrapper {
    margin-top: 21px;
  }

  .table-buyer {
    min-width: 1250px;
  }

  /* .table {
    .table-row {
      .company-name {
        flex: 1 1 auto;
        min-width: 150px;
      }

      .status {
        width: 7%;
        min-width: 95px;
      }
    }
  } */

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
